import * as React from 'react';
import { Balloon, Icon, Radio } from '@alifd/next';
import { setInventory } from '../../redux/reduces/skuSlice';
import getSkuInventory from '../../common/inventory';
import './index.scss'
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

const {useState, useEffect} = React;

export default function index(props: any) {
  const {inventory, i18n} = props;
  if (!inventory) return null;
  const {placeOfDispatches, preferedDispatchId, repoSkuInventory} = inventory;

  const dispatch = useAppDispatch();
  const [dispatchId, setDispatchId] = useState(preferedDispatchId);
  const skuInfo = useAppSelector(state => state.sku.goods)

  useEffect(() => {
    dispatch(setInventory({dispatchId}));
  }, [])

  if (placeOfDispatches.length === 1) return null;

  const handleChange = (val: string) => {
    // 更新sku
    dispatch(setInventory({dispatchId: val, skuInfo: getSkuInventory(skuInfo?.map, repoSkuInventory[val]?.skuMap)}));
    setDispatchId(val);
  }

  const renderRadio = (item: {id: string;name: string}) => {
    const inventorySkuInfo = repoSkuInventory[item.id].skuMap;
    const qunatity = Object.values(inventorySkuInfo).reduce((a, {inventoryCount}) => a + inventoryCount, 0);
    
    return <Radio value={item.id} disabled={qunatity === 0}>{item.name}</Radio>
  }
  
  return (
    <div className='inventory-dispatch'>
      <label>
        {i18n['pc.details.inventory.ship.from']}
        <Balloon
                trigger={<Icon type="prompt" size="small"/>}
                align="tr"
                alignEdge
                closable={false}
                triggerType="hover"
                style={{
                    width: 300
                }}
            >
              <span dangerouslySetInnerHTML={{
                __html: i18n['pc.details.inventory.ship.tips'].replace('{0}','<strong>').replace('{1}','</strong>')
              }}></span>
            </Balloon>  
      </label>
      <div className='inventroy-radio'>
      <Radio.Group onChange={handleChange} value={dispatchId}>
        {placeOfDispatches.map((item: { id: string; name: string }) => renderRadio(item))}
      </Radio.Group>
      </div>
    </div>
  )
}
